import { marked } from 'marked';

function setupLinkRender() {
  const linkRenderer = new marked.Renderer();
  linkRenderer.link = function (href: string, title: string, text: string) {
    let external = true,
      newWindow,
      out;

    // We are using parent bacause we are in a iframe.
    const location = window.location;
    if (location.origin === 'undefined' || location.origin === 'null') {
      (location as any).origin = location.protocol + '//' + location.host;
    }

    if (href.indexOf(location.origin) > -1) {
      external = false;
    }

    if (external === true || title === 'newWindow') {
      newWindow = true;
    }

    out = '<a href="' + href + '"';
    if (newWindow) {
      out += ' rel="noopener noreferrer"';
      out += ' target="_blank"';
    }
    if (title && title !== 'newWindow') {
      out += ' title="' + title + '"';
    }
    out += '>' + text + '</a>';
    return out;
  };

  return linkRenderer;
}

marked.setOptions({
  renderer: setupLinkRender(),
  gfm: true,
  breaks: true,
  mangle: false,
});

export type MarkdownProcessor = (markdown: string) => string;

const defaultMarkdownPreProcessors: MarkdownProcessor[] = [
  // To find lines that start with four spaces but should not form a code block <code> that is intervening html rendering
  (md) => md.replace(/^( {4})+/gm, (match) => match.replace(/ {4}/g, '')),
  // Ensure blockquote lines are followed by a blank line if the next line doesn't start with >
  // This regex finds: (line starting with >) followed by (newline) followed by (line NOT starting with > or blank;
  (md) => md.replace(/^(>.*?)(\n)(?!>|\n)/gm, '$1\n\n'),
  // Ensure list items are preceded by a blank line when they come after a line of text
  // But NOT when a list item follows another list item
  (md) => md.replace(/^(?![*\-+] )(.+)(\n)(?=[*\-+] )/gm, '$1\n\n'),
];

export function preprocessMarkdown(
  md: string,
  extraPreProcessors: MarkdownProcessor[] = [],
): string {
  const processors = [...defaultMarkdownPreProcessors, ...extraPreProcessors];
  return processors.reduce((acc, processor) => processor(acc), md);
}

export default function markdownToHTML(
  markdown: string,
  extraPreProcessors: MarkdownProcessor[] = [],
): string {
  const processedMarkdown = preprocessMarkdown(markdown, extraPreProcessors);
  return marked(processedMarkdown).trim();
}
